import {
	Chip,
	CircularProgress,
	FormControl,
	FormHelperText,
	MenuItem,
	Select,
	Typography,
	styled,
} from '@mui/material';

type StyledPlanPlaceholderProps = {
	$hasError?: boolean;
};

const StyledPlanFormControl = styled(FormControl)`
	width: 100%;
`;

const StyledPlanSelect = styled(Select)`
	& .MuiSelect-select {
		display: flex;
		align-items: center;
		text-align: left;
	}
`;

const StyledPlanMenuItem = styled(MenuItem)`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 8px;
	padding: 12px 16px;
`;

const StyledPlanChip = styled(Chip)`
	align-self: flex-start;
	height: 20px;
	font-size: 0.75rem;
	font-weight: 500;
	color: ${({theme}) => theme.palette.text.primary};
`;

const StyledPlanValidity = styled(Typography)`
	color: ${({theme}) => theme.palette.text.primary};
	font-size: 0.75rem;
	white-space: nowrap;
`;

const StyledPlanPlaceholder = styled(Typography)<StyledPlanPlaceholderProps>`
	color: ${({$hasError, theme}) =>
		$hasError ? theme.palette.error.main : theme.palette.text.secondary};
`;

const StyledPlanFormHelperText = styled(FormHelperText)`
	margin: 6px 0 0;
`;

const StyledPlanLoading = styled(CircularProgress)`
	margin-right: 16px;
`;

export {
	StyledPlanChip,
	StyledPlanFormControl,
	StyledPlanFormHelperText,
	StyledPlanLoading,
	StyledPlanMenuItem,
	StyledPlanPlaceholder,
	StyledPlanSelect,
	StyledPlanValidity,
};
